import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { allIcons, allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import { setSelectedClient } from "../../../lib/CompanySlice/SelectedClientSlice";

const SelectedClientDetails = () => {
  const dispatch = useDispatch();
  // Redux states
  const { selectedClient } = useSelector(
    (state) => state.selectedClientReducer
  );
  const selectedUser = {
    username: "John Doe",
    image: allImages.dumyMen1,
    contact: "+923444200515",
    address: " Wah Cantt Taxila, Islamabad",
    email: "johndoe@gmail.com",
  };

  const clientInfo = [
    {
      icon: allIcons.phoneOutgoingIcon,
      title: selectedUser.contact,
    },
    {
      icon: allIcons.googleLogoIcon,
      title: selectedUser.email,
    },
    {
      icon: allIcons.smileyInactive,
      title: t("viewProfile"),
    },
  ];

  return (
    <Stack p={2} gap={1.5} alignItems={"center"} textAlign={"center"}>
      <Typography variant="h1" fontSize={"1.25rem"} fontWeight={500}>
        {t("clientDetails")}
      </Typography>
      <Avatar src={selectedUser?.image} sx={{ height: 100, width: 100 }} />
      <Box>
        <Typography variant="h1" fontSize={"1.125rem"} fontWeight={500}>
          {selectedUser?.username}
        </Typography>
        <Typography variant="body2" fontSize={"0.875rem"}>
          {selectedUser?.address}
        </Typography>
        <List sx={{ mt: 1 }}>
          {clientInfo?.map((valll, index) => {
            return (
              <ListItem sx={{ py: "2px", cursor: "pointer" }}>
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <img src={valll.icon} alt={valll.title} width={20} />
                </ListItemIcon>
                <ListItemText
                  primary={valll.title}
                  sx={{
                    "& .MuiListItemText-primary ": {
                      fontSize: "0.875rem",
                    },
                  }}
                />
              </ListItem>
            );
          })}
          {/* Remove selected client */}
          <ListItem sx={{ py: "2px", cursor: "pointer" }}>
            <ListItemIcon sx={{ minWidth: 30 }}>
              <img src={allIcons.deleteIcon} alt="00000000" width={20} />
            </ListItemIcon>
            <ListItemText
              primary={"Remove"}
              onClick={() => dispatch(setSelectedClient(null))}
              sx={{
                "& .MuiListItemText-primary ": {
                  fontSize: "0.875rem",
                },
              }}
            />
          </ListItem>
        </List>
        <GlobalButton
          btnText={"chatWithMe"}
          startIcon={
            <img src={allIcons.chatWhiteIcon} alt={"chat-icon"} width={20} />
          }
          styleProps={{
            marginTop: "10px",
            height: 40,
            fontWeight: 400,
            textTransform: "lowercase",
          }}
        />
      </Box>
    </Stack>
  );
};

export default SelectedClientDetails;
